import styled from "styled-components";
import { Col } from "antd";
import {
  BASE_COLORS,
  FONT_FAMILY,
  FONT_SIZE_PX,
  FONT_WEIGHT,
  LAYOUT,
  media,
} from "config/theme/constants";

export const RightSideCol = styled(Col)`
  padding: ${LAYOUT.desktop.paddingVertical} ${LAYOUT.desktop.paddingHorizontal};
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${LAYOUT.desktop.headerHeight});
  background-color: var(--sider-background-color);
  overflow-y: auto;
`;

export const LeftSideCol = styled(Col)`
  @media only screen and ${media.xl} {
    padding: ${LAYOUT.desktop.paddingVertical}
      ${LAYOUT.desktop.paddingHorizontal};
    height: calc(100vh - ${LAYOUT.desktop.headerHeight});
    overflow: auto;
  }
`;

export const Space = styled.div`
  margin: 1rem 0;
`;

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 250px;

  .ant-card-body {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }
`;

export const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 15px;

  background: black;

  min-height: 300px;
  overflow-y: auto;
`;

export const Item = styled.div`
  background: red;
  height: 150px;
  flex-shrink: 0;
`;

export const DashboardWrapper = styled.div`
  .page-title {
    font-size: ${FONT_SIZE_PX.FONT23};
    font-weight: ${FONT_WEIGHT.normal};
    font-family: ${FONT_FAMILY.main};
    color: ${BASE_COLORS.downRiver};
    opacity: 1;
  }

  .link {
    text-decoration: underline;
    color: ${BASE_COLORS.bostonBlue};
    font-family: ${FONT_FAMILY.main};
    cursor: pointer;
  }
  .unlink {
    font-family: ${FONT_FAMILY.main};
  }

  .ant-card {
    box-shadow: inset 0 0 10px ${BASE_COLORS.altolight};
  }

  .ant-card .ant-card-body {
    padding: 15px;
  }

  .ant-table-thead .ant-table-cell {
    background-color: ${BASE_COLORS.curiousBlue};
    color: ${BASE_COLORS.white};
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    font-weight: ${FONT_WEIGHT.regular};
  }

  .ant-table-wrapper .ant-table.ant-table-small {
    font-size: ${FONT_SIZE_PX.xxs};
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:first-child {
    border-start-start-radius: unset;
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:last-child {
    border-start-end-radius: unset;
  }
`;

export const LinkText = styled.a`
  color: ${BASE_COLORS.curiousBlue};
`;
export const DashboardFilterWrapper = styled.div`
  .ant-card-head {
    padding: 12px 12px 12px 24px;
  }
  .ant-card-body {
    padding: 12px 12px 12px 24px;
  }
  .ant-statistic-content {
    font-size: 16px;
  }
  .ant-radio-button-wrapper {
    border: none !important;
    background-color: rgb(249 250 251);
    padding: 8px 12px;
    height: auto;
    &:before {
      display: none;
    }
    &:hover{
       color: ${BASE_COLORS.curiousBlue};
    }
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background: white !important;
    border-color: white !important;
  }
  .ant-radio-button-wrapper-checked {
    background: white !important;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid transparent !important;
    span {
      color: ${BASE_COLORS.curiousBlue};
      font-weight: 600;
    }
  }
  .ant-radio-group {
    border: 1px solid transparent;
    background-color: rgb(249 250 251);
    border-radius: 8px;
    padding: 0px 4px;
  }
`;
